import EditTemplate from "../_templates/EditTemplate";
import { competitionSchema } from "../../../schemas/competition.schema";
import {
  getCompetition,
  updateCompetition,
} from "../../../api/competitions.api";

export default function EditCompetition() {
  return (
    <EditTemplate
      title="Edit Competition"
      schema={competitionSchema}
      fetchFn={getCompetition}
      updateFn={updateCompetition}
      redirectPath="/cricket/competitions"
    />
  );
}
 